<flx-modal
  [dismissible]="true"
  (dismiss)="onDismiss()"
  class="flx-ds large flex flex-col"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
    data-testid="modify-variables-view-title"
  >
    Modify Variables
  </div>
  <div flxModalHeaderSubtitle>
    <ng-content select="[subtitle]" />
  </div>
  <div class="flx-modal-body">
    <ng-content select="[info]" />

    @if (loader()) {
      <div
        class="absolute top-0 left-0 z-10 flex justify-center items-center w-full h-full"
        data-testid="variables-editor-loader"
      >
        <flx-spinner size="small" />
      </div>
    }

    <div class="h-full flex flex-col rounded-lg border border-neutral-100 overflow-hidden">
      <div
        class="flex items-center bg-neutral-50 p-2 gap-1 rounded-t-md border-b border-neutral-100 justify-between"
      >
        <flx-select
          [formControl]="languageFC"
          class="flx-ds small"
        >
          @for (option of editorLanguageSelectOptions; track option.value) {
            <flx-select-option [value]="option">
              {{ option.label }}
            </flx-select-option>
          }
        </flx-select>
        <button
          [disabled]="!canExecuteChanges()"
          (click)="toggleViewMode()"
          class="flx-ds small secondary"
          data-testid="review-changes-button"
          flxButton
        >
          {{ isEditMode() ? 'Review Changes' : 'Edit Variables' }}
        </button>
      </div>
      <div class="relative overflow-hidden w-full h-full">
        <div
          [class.hidden]="isDiffMode()"
          class="editor-absolute-container editor w-full h-full"
        >
          <flx-code-editor
            [formControl]="variablesFC"
            [options]="codeEditorOptions()"
            [forceShowErrors]="true"
            [readonly]="this.readOnly()"
            (errorsChange)="setDataValidity($event)"
            class="w-full h-full min-h-0 p-2 grow"
          />
        </div>
        <div
          [class.hidden]="isEditMode()"
          class="editor-absolute-container editor-compare w-full h-full"
        >
          <flx-monaco-diff-editor
            [options]="codeCompareEditorOptions()"
            [originalModel]="diffView().originalModel"
            [modifiedModel]="diffView().modifiedModel"
            class="w-full min-h-0 p-2 grow"
            data-testid="variables-diff-editor"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="onDismiss()"
        class="flx-ds secondary"
        data-testid="cancel-button"
        flxButton
      >
        Cancel
      </button>
      <button
        [disabled]="!canExecuteChanges()"
        (click)="saveChanges()"
        class="flx-ds primary"
        data-testid="execute-changes-button"
        flxButton
      >
        Modify Variables
      </button>
    </div>
  </div>
</flx-modal>

<ng-template #confirmationModalTemplate>
  <h1 class="text-xl leading-8 text-neutral-900 text-center">
    Discard <span class="font-bold">Modify Variables</span>
  </h1>
  <p class="text-xs leading-5 text-left my-6">
    All the configurations will be lost and you will need to start over another Operation.
  </p>
</ng-template>
